const StatCard = ({ icon, label, value, sub, accent }) => (
  <div className="bg-bg-surface border border-border rounded-xl p-4 flex items-start gap-3">
    <div className={`p-2 rounded-lg ${accent ?? "bg-primary/10"}`}>{icon}</div>
    <div>
      <p className="text-xs text-text-muted mb-1">{label}</p>
      <p className="text-xl font-semibold text-text-primary">{value}</p>
      {sub && <p className="text-xs text-text-muted mt-0.5">{sub}</p>}
    </div>
  </div>
);

export default StatCard;
